<ui-search-input [placeholder]="'controls.search.placeholder' | translate" [formControl]="searchControl" (click)="onClick($event)" />
<div class="global-search-mobile-blur-overlay" *ngIf="opened$ | async"></div>
